import type { UserResponse } from '@/api/schema/data-contracts';
import type { TenantResponse } from '@/api/schema/data-contracts';

declare global {
  interface Window {
    ybug_settings: {
      id: string;
      user?: {
        id: string;
        username: string;
      };
      metadata?: {
        tenantId: string;
        tenantName: string;
      };
    };
  }
}

export const updateYbugSettings = (user: UserResponse | null, tenant: TenantResponse | null) => {
  if (window.ybug_settings && user && tenant) {
    window.ybug_settings.user = {
      id: user.id,
      username: user.email,
    };
    window.ybug_settings.metadata = {
      tenantId: tenant.id,
      tenantName: tenant.name,
    };
  }
};
